export const environment = {
  production: true,
  API_URL: 'https://api-cloud-vision.acttraining.org.uk/api/',
  // API_URL: 'https://api.acttraining-content.website/api/'
};



